import { createContext, Dispatch, SetStateAction } from 'react'
import { Step } from 'react-joyride'

type TutorialStepsInfo = Record<
  string,
  {
    steps: Step[]
  }
>

export type TutorialSettings = {
  run: boolean
  stepIndex: number
  steps: TutorialStepsInfo
}

export type TutorialSettingsContextValue = {
  tutorialSettings: TutorialSettings
  setTutorialSettings: Dispatch<SetStateAction<TutorialSettings>>
  handlePlay: () => void
  handleStop: () => void
}

const TutorialSettingsDefaultContext = {} as TutorialSettingsContextValue

export const TutorialSettingsContext =
  createContext<TutorialSettingsContextValue>(TutorialSettingsDefaultContext)
